import { Checkbox, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import AtterbergLimitChartSection from 'Components/Worksheets/AtterbergLimitWorksheet/Shared/ChartSection';
import { OptionalCharts } from 'Components/Worksheets/AtterbergLimitWorksheet/types';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import React from 'react';

let BsEnIsoResultsSectionMethodA: React.FC<IWithWorksheetInjectedProps> = () => {
  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <ListFieldSection>
        <Field input={<TextOutput />} name="LiquidLimitText" />
        <Field input={<TextOutput />} name="PlasticLimitText" />
        <Field input={<TextOutput />} name="PlasticityIndexText" />
      </ListFieldSection>
      <ListFieldSection heading="Optional Results">
        <Field input={<TextOutput />} name="LiquidityIndexText" />
        <Field input={<TextOutput />} name="ConsistencyIndex" />
        <Field input={<NumericInput />} name="ActivityIndexCorrectionFactor" />
        <Field input={<TextOutput />} name="ActivityIndex" />
      </ListFieldSection>
      <NamePrefixModifier namePrefix="plasticityChart">
        <AtterbergLimitChartSection wide height={500} />
      </NamePrefixModifier>
      <ListFieldSection heading="Report">
        <FieldSet>
          <Field input={<Checkbox />} name="ReportLiquidityIndex" />
          <Field input={<Checkbox />} name="ReportConsistencyIndex" />
          <Field input={<Checkbox />} name="ReportActivityIndex" />
        </FieldSet>
        <Field
          input={<RadioGroup />}
          name="OptionalCharts"
          options={[
            { label: 'None', value: OptionalCharts.None },
            { label: 'Plasticity Chart', value: OptionalCharts.PlasticityChart },
            { label: 'Liquid Limit Chart', value: OptionalCharts.LiquidLimitChart },
          ]}
        />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

BsEnIsoResultsSectionMethodA = withInjectedProps(BsEnIsoResultsSectionMethodA);

export { BsEnIsoResultsSectionMethodA };
export default BsEnIsoResultsSectionMethodA;
